<template>
  <div class="chapter_SDK" :class="[ getTerminalForChrome() ? 'chapter_SDK-mo': 'chapter_SDK-pc']">
    <div class="tech">
      <div class="tech-box" v-for="(v, i) in list" :key="i">
        <div class="bgc-layout" :style="{backgroundColor: v.color}"></div>
        <div class="tech-inner">
          <div class="tech-image" :style="{background: `url(${v.thumbUrl || defaultImg}) no-repeat`,backgroundSize: '100%'}" @click="v.categorytype == 1 ? toDetail(v) : toList(v)">
            <!-- <img :src="defaultImg" alt=""> -->
            <!-- <h3>{{v.title}}</h3> -->
          </div>
          <div class="tech-txt">
            <p class="desc">{{v.description || ''}}</p>
            <div class="button" @click="v.categorytype == 1 ? toDetail(v) : toList(v)">
              <p class="text">查看详情</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="list">
      <div class="list-item" v-for="(v, i) in list" :key="i">
        <div
          class="left"
          :class="[v.actived ? 'actived': '']"
          @click="handleChange(v.url, v.title)"
        >{{v.title}}</div>
      </div>
    </div>
    <div class="right">
      <div v-html="content" v-if="content" class="r-c"></div>
      <div v-else>
        <div class="sub-list">
          <div class="item" v-for="(v, i) in subList" :key="i">
            <div class="image" @click="toDetail(v)">
              <img :src="v.thumbUrl || defaultImg" alt />
              <span class="wave"></span>
                <span class="wave"></span>
              <span class="wave"></span>
            </div>
            <div class="title" @click="toDetail(v)">{{v.surveytitle}}</div>
            <div class="date">[{{v.rec_createdtime_str}}]</div>
          </div>
        </div>
        <Page :total="total" show-total @on-change="pageChange" style="text-align: center"></Page>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { fetchSurvey } from '@/api/school';
import { DataType } from '@/utils';
export default {
  data() {
    return {
      list: [],
      subList: [],
      params: {
        pageNumber: 1,
        pageSize: 8,
        category: this.$route.query.id
      },
      total: 0,
      content: '',
      defaultImg: require('../../assets/default.jpeg')
    };
  },
  watch: {
    '$route.query': function(val) {
      this.params.category = val.id;
      this._fetchSurvey();
    },
    MENU_LIST(val) {
      // console.log('val', val)
      const menu = [...val];
      const str = '学校概况';
      const path = this.$route.fullPath;
      if (menu && menu.length) {
        menu.forEach(v => {
          if (v.title === str) {
            // this.list = v.children
            v.children.forEach(m => {
              if (m.url === path) {
                m.actived = true;
              } else {
                m.actived = false;
              }
            });
            this.list = v.children;
          }
        });
      }
    }
  },
  computed: {
    ...mapState({
      MENU_LIST: function(state) {
        // console.log('state', state)
        const menu = [...state.MENU_LIST];
        const str = '学校概况';
        const path = this.$route.fullPath;
        if (menu && menu.length) {
          menu.forEach(v => {
            if (v.title === str) {
              // this.list = v.children
              v.children.forEach(m => {
                if (m.url === path) {
                  m.actived = true;
                } else {
                  m.actived = false;
                }
              });
              this.list = v.children;
            }
          });
        }
        return state.MENU_LIST;
      }
    })
  },
  methods: {
    ...mapGetters(['getTerminalForChrome']),
    toList(val) {
      // const nav = JSON.parse(sessionStorage.getItem('nav'))
      // nav.second = val.title
      // nav.third = ''
      // this.$parent.nav.second = val.title
      // sessionStorage.setItem('nav', JSON.stringify(nav))
      this.$router.push({
        path: `surveylist?id=${val.rec_id}`
      })
    },
    toDetail(val) {
      // bus.detailContent = val
      // sessionStorage.setItem('detailMsg', JSON.stringify(val))
      this.$router.push({
        path: `/detail?categorybelong=${val.categorybelong}&rec_id=${val.rec_id}`
      });
    },
    pageChange(val) {
      this.params.pageNumber = val;
      this._fetchSurvey();
    },
    handleChange(val, title) {
      this.list.forEach(v => {
        if (v.url === val) {
          v.actived = true;
        } else {
          v.actived = false;
        }
      });
      this.$parent.nav.second = title;
      this.$parent.nav.secondUrl = val;
      this.$router.push({
        path: val
      });
    },
    _fetchSurvey() {
      fetchSurvey({ ...this.params }).then(res => {
        if (res.status === 200) {
          const { data } = res.data;
          if (DataType(data, 'array')) {
            this.content = '';
            this.subList = data;
            this.total = res.data.totalCount;
          } else {
            this.content = data.content;
          }
        }
      });
    }
  },
  created() {},
  mounted() {
    this._fetchSurvey();
  }
};
</script>

<style lang="scss">
.chapter_SDK-pc {
  // background-color: red;
  padding-top: 30px;
  .tech {
    .tech-box {
      width: 100%;
      height: 450px;
      clear: both;
      position: relative;
      .bgc-layout {
        width: 100%;
        position: absolute;
        top: 50px;
        height: 230px;
        z-index: -1;
      }
      .tech-inner {
        width: 1010px;
        margin: 0 auto;
        position: relative;
        z-index: 1;
        .tech-image {
          width: 640px;
          height: 330px;
          background-color: red;
          text-align: center;
          line-height: 330px;
          position: relative;
          cursor: pointer;
          transition: transform .3s;
          &:hover {
            transform: scale(1.1);
          }
          // &::before {
          //   background-color: rgba(0, 0, 0, .2);
          //   position: absolute;
          //   left: 0;
          //   top: 0;
          //   right: 0;
          //   bottom: 0;
          //   content: '';
          //   z-index: 0;
          // }
          h3 {
            font-weight: bold;
            color: #fff;
            font-size: 48px;
            position: absolute;
            z-index: 2;
            left: 50%;
            transform: translateX(-50%);
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
        }
        .tech-txt {
          width: 420px;
          padding: 30px;
          position: absolute;
          background-color: #fff;
          border-radius: 4px;
          border: 1px solid #eee;
          box-shadow: 0px 1px 2px rgba(0,0,0,.2);
          .desc {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .button {
            width: 360px;
            background-color: #fff;
            border: 1px solid #454545;
            // margin: 1em auto 0;
            padding: 10px 0px;
            // margin: 1em 0;
            margin-top: 1em;
            clear: both;
            display: block;
            text-align: center;
            position: relative;
            overflow: hidden;
            z-index: 2;
            cursor: pointer;
            .text {
              
            }
            &:hover {
              .text {
                color: #fff;
              }
            }
            &::after {
              position: absolute;
              z-index: -1;
              display: block;
              content: '';
              transition: all .3s;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              // background-color: #454545;
            }
            &:hover::after {
              transform: scale(2) rotate(180deg);
              background-color: #454545;
              // z-index: 0;
            }
            &::before {
              position: absolute;
              z-index: -1;
              display: block;
              content: '';
              transition: all .3s;
            }
          }
        }
      }
      &:nth-of-type(odd) {
        .tech-txt {
          top: 160px;
          right: 0;
        }
      }
      &:nth-of-type(even) {
        .tech-image {
          float: right;
        }
        .tech-txt {
          top: 160px;
          left: 0;
        }
      }
    }
  }
}
.chapter_SDK-mo {
  padding-top: 4vw;
  .tech {
    .tech-box {
      width: 100%;
      height: auto;
      clear: both;
      position: relative;
      margin-bottom: 5.33vw;
      .bgc-layout {
        width: 100%;
        height: 60vw;
        position: absolute;
        top: 6.67vw;
        z-index: -1;
      }
      .tech-inner {
        width: 80%;
        margin: 0 auto;
        position: relative;
        clear: both;
        .tech-image {
          height: 50vw;
          text-align: center;
          // line-height: 50vw;
          position: relative;
          &::before {
            content: '';
            position: absolute;
            background-color: rgba(0,0,0,.2);
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
          }
          h3 {
            font-weight: bold;
            color: #fff;
            font-size: 6.4vw;
            position: absolute;
            z-index: 2;
            transform: translate(-50%, -50%);
            left: 50%;
            top: 50%;
          }
        }
        .tech-txt {
          background-color: #fff;
          padding: 3.2vw;
          .desc {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          .button {
            width: 100%;
            height: 10.67vw;
            text-align: center;
            line-height: 10.67vw;
            margin-top: 1.33vw;
            background-color: #fff;
            border: 1px solid #454545;
          }
        }
      }
    }
  }
}
// .chapter_SDK-pc {
//   padding-top: 72px;
//   padding-bottom: 32px;
//   display: flex;
//   .list {
//     // display: flex;
//     .list-item {
//       display: flex;
//       .left {
//         cursor: pointer;
//         width: 81px;
//         height: 81px;
//         border-radius: 50%;
//         font-size: 18px;
//         color: #d2d2d2;
//         // letter-spacing: 2.25px;
//         border: 3px solid #d2d2d2;
//         // text-align: center;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         padding: 0px 16px;
//         text-align: justify;
//         text-align-last: justify;
//         word-break: break-all;
//         margin-right: 49.5px;
//         &.actived {
//           border-color: #53adaa;
//           color: #31a087;
//         }
//       }
//       &:not(:last-child) {
//         margin-bottom: 40px;
//       }
//     }
//   }
//   .right {
//     display: inline-block;
//     position: relative;
//     padding: 40px;
//     width: 1220px;
//     min-height: 415px;
//     background: #61afb1;
//     border-radius: 4px;
//     color: #fff;
//     box-shadow: 6px 6px 4px #888888;
//     .r-c {
//       span {
//         color: #fff !important;
//       }
//     }
//     .qu {
//       width: 0;
//       height: 0;
//       border-width: 16px;
//       border-style: solid;
//       border-color: transparent #61afb1 transparent transparent;
//       position: absolute;
//       left: -32px;
//       top: 20px;
//     }
//     .sub-list {
//       display: flex;
//       flex-wrap: wrap;
//       .item {
//         width: 318px;
//         margin: 0px 26px;
//         margin-bottom: 16px;
//         .image {
//           // border: 1px solid #fff;
//           box-shadow: 0px 2px 4px 0px rgb(0, 0, 0);
//           // width: 318px;
//           width: 100%;
//           height: 230px;
//           opacity: 0.9;
//           cursor: pointer;
//           overflow: hidden;
//           position: relative;
//           transition: transform 0.3s;
//           img {
//             width: 100%;
//             height: 100%;
//             object-fit: fill;
//           }
//           &:hover {
//             transform: scale(1.1);
//             .wave {
//               position: absolute;
//               width: 550px;
//               height: 550px;
//               top: 200px;
//               left: -100px;
//               background-color: rgba(111, 194, 243, 0.3);
//               border-radius: 38%;
//               animation: drift 5s linear infinite;
//             }

//             .wave:nth-of-type(1) {
//               animation-duration: 5s;
//             }

//             .wave:nth-of-type(2) {
//               animation-duration: 7s;
//             }

//             .wave:nth-of-type(3) {
//               animation-duration: 10s;
//             }

//             @keyframes drift {
//               from {
//                 transform: rotate(180deg);
//               }
//             }
//           }
//         }
//         .title {
//           margin: 16px 0px;
//           font-size: 16px;
//           color: #ffffff;
//           text-align: center;
//           cursor: pointer;
//         }
//         .date {
//           font-size: 14px;
//           color: #f5f5f5;
//           text-align: center;
//         }
//       }
//     }
//   }
// }
// .chapter_SDK-mo {
//   padding: 6.4vw 3.2vw;
//   display: flex;
//   .list {
//     width: 12.67vw;
//     .list-item {
//       width: 100%;
//       .left {
//         width: 100%;
//         height: 12.67vw;
//         background: #ffffff;
//         border: 0.4vw solid #d2d2d2;
//         border-radius: 50%;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         padding: 0px 2.4vw;
//         text-align: justify;
//         text-align-last: justify;
//         word-break: break-all;
//         font-size: 3.2vw;
//         &.actived {
//           color: #31a087;
//           border-color: #53adaa;
//         }
//       }
//       &:not(:last-child) {
//         margin-bottom: 4.27vw;
//       }
//     }
//   }
//   .right {
//     background: #61afb1;
//     width: calc(100% - 12.67vw - 3.2vw);
//     margin-left: 3.2vw;
//     padding: 4.27vw;
//     border-radius: 0.53vw;
//     color: #fff;
//     box-shadow: 6px 6px 4px #888888;
//     .r-c {
//       img {
//         width: 100% !important;
//         height: 100% !important;
//         object-fit: contain;
//       }
//       span {
//         color: #fff !important;
//       }
//     }
//     .sub-list {
//       // margin: 0 auto;
//       display: flex;
//       flex-wrap: wrap;
//       justify-content: center;
//       .item {
//         width: 45.87vw;
//         margin-bottom: 2.13vw;
//         .image {
//           width: 100%;
//           height: 34.71vw;
//           box-shadow: 0px 2px 4px 0px;
//           img {
//             width: 100%;
//             height: 100%;
//             object-fit: fill;
//           }
//         }
//         .title {
//           font-size: 3.2vw;
//           color: #fff;
//           text-align: center;
//           margin: 2.13vw 0vw;
//         }
//         .date {
//           font-size: 3.2vw;
//           text-align: center;
//           color: #f5f5f5;
//         }
//       }
//     }
//   }
// }
</style>
